/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LoveInputs */

const en_love = /** @type {(inputs: LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Love & Romance`)
};

const es_love = /** @type {(inputs: LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amor y Romance`)
};

const fr_love = /** @type {(inputs: LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amour et Romance`)
};

const de_love = /** @type {(inputs: LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liebe & Romantik`)
};

const ja_love = /** @type {(inputs: LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`愛＆ロマンス`)
};

const zh_love = /** @type {(inputs: LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`爱情与浪漫`)
};

const ar_love = /** @type {(inputs: LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحب والرومانسية`)
};

const id_love = /** @type {(inputs: LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cinta & Romansa`)
};

const it_love = /** @type {(inputs: LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amore & Romantico`)
};

const ru_love = /** @type {(inputs: LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Любовь и Романтика`)
};

const pt_love = /** @type {(inputs: LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amor e Romance`)
};

const ko_love = /** @type {(inputs: LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사랑 및 로맨스`)
};

/**
* | output |
* | --- |
* | "Love & Romance" |
*
* @param {LoveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const love = /** @type {((inputs?: LoveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LoveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_love(inputs)
	if (locale === "es") return es_love(inputs)
	if (locale === "fr") return fr_love(inputs)
	if (locale === "de") return de_love(inputs)
	if (locale === "ja") return ja_love(inputs)
	if (locale === "zh") return zh_love(inputs)
	if (locale === "ar") return ar_love(inputs)
	if (locale === "id") return id_love(inputs)
	if (locale === "it") return it_love(inputs)
	if (locale === "ru") return ru_love(inputs)
	if (locale === "pt") return pt_love(inputs)
	return ko_love(inputs)
});